import { useState } from "react";
import { PlusIcon, MinusIcon } from "@heroicons/react/20/solid";
import { offsetNumber } from "../../utils/config";

const PaginationButtons = ({
  backButtonOnClick,
  nextButtonOnClick,
  page,
  totalCount,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const maxPages = Math.ceil(totalCount / offsetNumber); // Total number of pages

  return (
    <div className="flex justify-center items-center gap-4 mt-2">
      {/* Previous Page Button */}
      <button
        disabled={isLoading || page <= 1}
        onClick={async () => {
          if (page <= 1) return; // Prevent invalid navigation
          setIsLoading(true);
          await backButtonOnClick();
          setIsLoading(false);
        }}
        className="p-2 disabled:opacity-50"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="icon icon-tabler icons-tabler-outline icon-tabler-arrow-left"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M5 12l14 0" />
          <path d="M5 12l6 6" />
          <path d="M5 12l6 -6" />
        </svg>
      </button>

      {/* Page Counter */}
      <div className="flex items-center justify-center min-w-[80px] font-medium text-sm">
        {isLoading ? (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="animate-spin h-5 w-5"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke={"#5729BC"}
            fill={"none"}
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M21 12a9 9 0 1 1-6.219-8.56" />
          </svg>
        ) : (
          `${page} / ${maxPages}`
        )}
      </div>

      {/* Next Page Button */}
      <button
        disabled={isLoading || page >= maxPages}
        onClick={async () => {
          if (page >= maxPages) return; // Prevent exceeding max pages
          setIsLoading(true);
          await nextButtonOnClick();
          setIsLoading(false);
        }}
        className="p-2 disabled:opacity-50"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="icon icon-tabler icons-tabler-outline icon-tabler-arrow-right"
        >
          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
          <path d="M5 12l14 0" />
          <path d="M13 18l6 -6" />
          <path d="M13 6l6 6" />
        </svg>
      </button>
    </div>
  );
};

export default PaginationButtons;
